<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.header(slot='header')
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="activeRefreshResults")
        ods-tooltip(:content='$t("mailServer.new")', placement='bottom')
          ods-button(
              size='medium',
              icon='ods-icon-upload'
              @click.native='handleNewMailServer')
              | {{ $t('invoices.buttons.upload_invoice') }}
      div(slot='body')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bSearchBar from '@/components/B2bSearchBar'
import Utils from '@/components/shared/Utils'
import router from '@/router/index'

export default {
  name: 'b2b-filters-mailServer',

  props: {},
  mixins: [Utils],
  components: {
    B2bSearchBar
  },
  data () {
    return {}
  },

  computed: {
    ...mapGetters([
      'queryMailServer'
    ])
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getMailServer',
      'queryMailServerState'
    ]),

    /* Ir al alta de un servidor de correo */
    handleNewMailServer (mailServer) {
      router.push({
        name: 'mailServer-new',
        params: {
          mailServerId: 'newMailServer'
        }
      })
    },

    onSubmit (formName) {
      console.log(formName)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: 'Añadiendo el filtro seleccionado a la búsqueda ...'
          })
          try {
            await this.queryMailServerState(this.queryMailServer)
            dataQuery.query = this.queryMailServer
            await this.getMailServer(dataQuery)
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!')
        }
      })
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        await this.queryMailServerState(this.queryMailServer)
        dataQuery.query = this.queryMailServer
        await this.getMailServer(dataQuery)
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = this.$t('error.e400')
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    try {
      await this.queryMailServerState(this.queryMailServer)
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {

  }
}
</script>

<style lang="scss" scoped>
.b2b-filters{
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: $--color-white;
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 .2rem .8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader {
    font-size: 12px;
    padding: 0 28px 0 20px;
    color: var(--color-txt-secondary);
  }

  .ods-button{
    display: inline;
    margin-right: rem(24);
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
</style>
